import { Component } from '@ecs/Component';

export class ChargeEffectRequest implements Component {
  readonly type = 'ChargeEffectRequest';
  
  constructor(
    public x: number,
    public y: number,
    public weaponAngle: number,
    public chargeProgress: number,
    public particleCount: number = 3,
    public baseColor: string = '#ff00ff'
  ) {}
}